import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Color} from "../types/Color";
import {EstimatedProduct} from "../types/EstimatedProduct";
import {OptionalProduct} from "../types/OptionalProduct";

const emptyArray: OptionalProduct[] = [];

export const useGetOptionalProducts = (dealerID: number, prodQteGrpIDs: number[], zipCode: string, enabled: boolean) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-tool-colors', dealerID, dealerID, zipCode, JSON.stringify(prodQteGrpIDs)],
        queryFn: async () => await apiClient.get('ee-tool/optional-products?dealerID=' + dealerID + '&prodQteGrpIDs=' + prodQteGrpIDs.join(',') + '&zipCode=' + zipCode) as OptionalProduct[],
        enabled: enabled && prodQteGrpIDs && prodQteGrpIDs.length > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || emptyArray,
        isLoading: isLoading
    };
};
